import type { PlanCode, PrototypeRuntime, Root } from "./prototypeTypes";
import type { PrototypeApiCall } from "./apiContracts";

export function exposeSmokeHelpers(
  root: HTMLElement,
  runtime: PrototypeRuntime,
	state: { isLoggedIn: boolean; currentPlan: PlanCode; effectiveAccessPlan?: PlanCode },
  actions: {
    showView(view: string, root: Root): void;
    setActiveTab(view: string, root: Root): void;
    showTopicDetail(topic: string, root: Root): void;
    showArticle(chapter: number, root: Root): void;
    openModal(root: Root, id: string): void;
    closeAllModals(root: Root): void;
    hideLoginState(root: Root): void;
    refreshHomeState(root: Root): void;
    loadViewData(view: string, runtime: PrototypeRuntime, state: { isLoggedIn: boolean; currentPlan: PlanCode }): Promise<void>;
    nextMonthIso(): string;
    setCurrentPlan(plan: PlanCode): void;
  },
) {
  window.__deepmoxPrototype = {
    showView: (view: string) => {
      actions.showView(view, root);
		void actions.loadViewData(view, runtime, { isLoggedIn: state.isLoggedIn, currentPlan: state.effectiveAccessPlan ?? state.currentPlan });
    },
    setActiveTab: (view: string) => actions.setActiveTab(view, root),
    showTopicDetail: (topic: string) => {
      runtime.activeCourseId = topic;
      actions.showTopicDetail(topic, root);
    },
    showArticle: (chapter: number) => {
      runtime.activeChapterIndex = chapter;
      actions.showArticle(chapter, root);
    },
    openModal: (id: string) => actions.openModal(root, id),
    closeAllModals: () => actions.closeAllModals(root),
    hideLoginGate: () => actions.hideLoginState(root),
    setPlan: (plan: PlanCode) => {
      actions.setCurrentPlan(plan);
      actions.refreshHomeState(root);
    },
    getApiCalls: () => runtime.api.calls,
    clearApiCalls: () => {
      runtime.api.calls.splice(0, runtime.api.calls.length);
      window.__deepmoxApiCalls = runtime.api.calls;
    },
    updateEmailPreferences: () => runtime.api.updateEmailPreferences({ product: true, marketing: false }),
    setAutoRenew: (enabled: boolean) => runtime.api.setAutoRenew(enabled, actions.nextMonthIso(), runtime.subscriptionId),
    lastApiError: () => runtime.lastApiError,
  };
}

declare global {
  interface Window {
    __deepmoxPrototype?: {
      showView(view: string): void;
      setActiveTab(view: string): void;
      showTopicDetail(topic: string): void;
      showArticle(chapter: number): void;
      openModal(id: string): void;
      closeAllModals(): void;
      hideLoginGate(): void;
      setPlan(plan: PlanCode): void;
      getApiCalls(): unknown[];
      clearApiCalls(): void;
      updateEmailPreferences(): Promise<unknown>;
      setAutoRenew(enabled: boolean): Promise<unknown>;
      lastApiError(): string | null;
    };
    __deepmoxApiCalls?: PrototypeApiCall[];
  }
}
